import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import MultiCartOfferComparisonModal from './Modal/MultiCartOfferComparisonModal'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React, { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { MultiCartContext } from 'machines/cart/MultiCartMachineProvider'
import { useSelector } from '@xstate/react'
import { isSpoofed } from 'selectors/featuresSelectors'

const StyledMobileContainer = styled(Group)`
  padding: 0 ${rem(16)};
`

function MultiCartComparisonBanner() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const isSpoofedEnabled = useAppSelector(isSpoofed)

  const multiCartActorRef = MultiCartContext.useActorRef()
  const { cartActiveComparison } = useSelector(multiCartActorRef, (snapshot) => ({
    cartActiveComparison: snapshot.context.cartActiveComparisons.status === 'loaded' && snapshot.context.activeCartId
      ? snapshot.context.cartActiveComparisons.data[snapshot.context.activeCartId] || []
      : [],
  }))

  const showUserCartComparisonBanner = useMemo(() => (
    !isSpoofedEnabled && cartActiveComparison && cartActiveComparison.length > 0
  ), [isSpoofedEnabled, cartActiveComparison])

  const openComparisonModal = () => {
    showModal(<MultiCartOfferComparisonModal mode="user-cart" />)
  }

  const headingText = intl.formatMessage({
    id: 'JANcb-9XchvmOpO78jBW',
    defaultMessage: 'Your agent has shared a tailored comparison',
    description: 'Heading for the agent comparison banner on the cart page',
  })

  const viewComparisonText = intl.formatMessage({
    id: 'sXVcOzDF2pPTNZMGWBIB',
    defaultMessage: 'View comparison',
    description: 'Action button label to open the agent comparison modal',
  })

  const sideComparisonText = intl.formatMessage({
    id: 'KAq-lIjYSw2dtHELd9HZ',
    defaultMessage: 'Side-by-side comparison to help you decide.',
    description: 'Supporting descriptive message shown below the agent cart comparison banner',
  })

  if (!showUserCartComparisonBanner) {
    return null
  }

  return (
    <>
      <CSSBreakpoint min="tablet">
        <MessageBanner
          kind="informational-primary"
          icon={<LinePhoneIcon />}
          heading={headingText}
          primaryActionButtonProps={{
            children: viewComparisonText,
            onClick: openComparisonModal,
            shape: 'round',
          }}
        >
          {sideComparisonText}
        </MessageBanner>
      </CSSBreakpoint>
      <CSSBreakpoint max="mobile">
        <StyledMobileContainer direction="horizontal" gap={8}>
          <LinePhoneIcon />
          <Group direction="vertical" horizontalAlign="start" gap={8}>
            <Group direction="vertical" gap={4}>
              <BodyText variant="medium" weight="bold">{headingText}</BodyText>
              <BodyText variant="medium">{sideComparisonText}</BodyText>
            </Group>
            <TextButton kind="secondary" shape="round" onClick={openComparisonModal}>{viewComparisonText}</TextButton>
          </Group>
        </StyledMobileContainer>
      </CSSBreakpoint>
    </>
  )
}

export default MultiCartComparisonBanner
